// extracted by mini-css-extract-plugin
export default {"wrapper":"ToastAddressCopied_wrapper__5nPRS","disabled":"ToastAddressCopied_disabled__su1qN","content":"ToastAddressCopied_content__Z-xPq"};